import { defineStore } from "pinia";
import { globals_actions, globals_getters, globals_state } from "./globals";

export const useGlobalsStore = defineStore("globals", {
  state: () => Object.assign({}, globals_state),
  actions: globals_actions,
  getters: globals_getters
});
